import TagManager from "react-gtm-module";

function ExploreCollegesLocation({ ipeds }) {
  const tagManagerArgs = {
    dataLayer: {
      event: "interactionEvent",
      eventName: "explore_colleges_location",
      ipeds: ipeds,
    },
  };

  TagManager.dataLayer(tagManagerArgs);
}

export default ExploreCollegesLocation;
